<script setup>
import Message from 'primevue/message';

defineProps(['error'])
</script>

<template>
    <Message v-if="error" severity="error" :closable="false">
        <div>{{error}}</div>
    </Message>
</template>
